<template>
  <div class="modal-overlay" @click="closeSuccessModal()">
    <div class="context">
      <div class="success-logo-container">
        <img :src="successImage" alt="Image icon" />
      </div>
      <h1>{{successTitle}}</h1>
      <p>{{successMessage}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: ['successMessage', 'successImage', 'successTitle'],
  methods: {
    closeSuccessModal() {
      this.$emit('closeSuccessModal');
    },
  },
};
</script>

<style scoped>
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20;
    background: rgba(20, 20, 20, 0.83);
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  .modal-overlay .context {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 21;
    width: 100%;
    height: 100%;
    background: var(--white);
    max-width: 921px;
    max-height: 654px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .success-logo-container img {
    position: relative;
  }
  .modal-overlay .context {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 600;
  }
  .modal-overlay .context h1 {
    font-size: 1.75rem;
    line-height: 2.125rem;
    color: #2f2e41;
    margin-bottom: 40px;
  }
  .modal-overlay .context p {
    font-size: 1.25rem;
    line-height: 2.125rem;
  }
</style>
